export { default } from './TreeItem';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TreeItem/index.js
// module id = 391
// module chunks = 0